"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldActionButton = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const ControlPoint_1 = __importDefault(require("@material-ui/icons/ControlPoint"));
const action_button_1 = require("../action-button");
const table_field_toolbar_button_1 = require("../../../components/table-field/table-field-toolbar-button");
exports.TableFieldActionButton = react_1.forwardRef(function TableFieldActionButton({ apiCall, ButtonComponent, ...restProps }, ref) {
    const TableToolbarButtonComponent = ButtonComponent !== null && ButtonComponent !== void 0 ? ButtonComponent : TableFieldToolbarButtonWrapper;
    const handleApiCall = event_callback_hook_1.useEventCallback((formData) => {
        return apiCall(formData);
    });
    return (react_1.default.createElement(action_button_1.ActionButton, Object.assign({ ButtonComponent: TableToolbarButtonComponent, apiCall: handleApiCall, ref: ref }, restProps)));
});
function TableFieldToolbarButtonWrapper({ disabled, label, tooltip, IconComponent, ...rest }) {
    return (react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, Object.assign({ disabled: disabled !== null && disabled !== void 0 ? disabled : false, title: tooltip, show: true, IconComponent: IconComponent !== null && IconComponent !== void 0 ? IconComponent : ControlPoint_1.default }, rest)));
}
//# sourceMappingURL=table-field-action-button.js.map